'use client';

import { HINT_RULES, readState, resetState, writeState, type HintState } from '@/lib/hints';

// The memory of the hints in this browser: local storage when it works, this visit's memory when it does not (a private window, a blocked
// store). A change in another tab arrives through the "storage" event, so two tabs never show the same hint twice.
export const HINTS_CHANGED = 'rec:hints-changed';
export const HINT_USED = 'rec:hint-used';

let memory: string | null = null;

function read(): string | null {
  try { return window.localStorage.getItem(HINT_RULES.storageKey) ?? memory; } catch { return memory; }
}

export function loadHints(now = Date.now()): HintState {
  return readState(read(), now);
}

export function saveHints(state: HintState): void {
  const raw = writeState(state);
  memory = raw;
  try { window.localStorage.setItem(HINT_RULES.storageKey, raw); } catch { /* the visit's memory is kept */ }
  window.dispatchEvent(new Event(HINTS_CHANGED));
}

/** "Show the tips again". */
export function resetHints(now = Date.now()): void {
  saveHints(resetState(now));
}

/** A feature that has no button of its own to click says it was used: its hint ends for good. */
export function markHintUsed(id: string): void {
  window.dispatchEvent(new CustomEvent(HINT_USED, { detail: { id } }));
}
